import mitt from 'mitt'
import type {ItemType} from "~/types/lineitem";

type ApplicationEvents = {
  'open-demofinder': undefined
  'untranslate': undefined
  'triggerScroll': undefined
  'add-product-by-product-id': {culture: string, productId: string, itemType: ItemType, quantity: number}
};

const emitter = mitt<ApplicationEvents>()

if (import.meta.client) {
  // @ts-expect-error -- window.useEvent is not in the Window type definition
  window.useEvent = emitter.emit
}
export const useEvent = emitter.emit
export const useListen = emitter.on
// Pair every useListen with a useUnlisten (e.g. onMounted / onBeforeUnmount);
// mitt keeps handlers forever, so an unpaired listener piles up per remount.
export const useUnlisten = emitter.off
